// extracted by mini-css-extract-plugin
export default {"gray":"Answer-module__gray--f4ea2","wrapper":"Icon-module__wrapper--e24cd","confidence":"Icon-module__confidence--ebc49"};